cb.define(['common/common_VM.Extend.js'], function (common) {
  var AA_aa_warehouse_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      common.initRegionAndPosition(viewmodel);

      viewmodel.on('afterLoadData', function (data) {
        //非浏览态下，所属客户是否可用根据库存组织是否有值来判断
        if (viewmodel.getParams().mode !== 'browse') {
          viewmodel.get('cust_name').setDisabled(data.org_name ? false : true);

          var userType = cb.rest.AppContext.user.userType;
          if (userType == 2 || userType == 3) {
            viewmodel.get('cust_name').setVisible(false);
            viewmodel.get('cust').setValue(cb.rest.AppContext.user.customer);
          } else {
            viewmodel.get('cust_name').setVisible(true);
          }
        }

      });



      viewmodel.get('org_name').on('afterValueChange', function () {
        //库存组织变化以后清空所属客户
        viewmodel.get('cust').setValue(null);
        viewmodel.get('cust_name').setValue(null);

        var stockOrg = viewmodel.get('org_name').getValue();
        if (stockOrg == null || stockOrg == "") {
          viewmodel.get('cust_name').setDisabled(true);
        } else {
          viewmodel.get('cust_name').setDisabled(false);
        }
      });




      viewmodel.on('afterEdit', function (data) {
        debugger
        //如果是客户操作员，就在仓库档案上不显示客户参照
        //如果是租户操作员，就在仓库档案上显示客户参照，允许编辑和修改，非必输项
        var userType = cb.rest.AppContext.user.userType;
        if (userType == 2 || userType == 3) {
          viewmodel.get('cust_name').setVisible(false);
          viewmodel.get('cust').setValue(cb.rest.AppContext.user.customer);
        } else {
          viewmodel.get('cust_name').setVisible(true);
        }
      });



      //参照弹出前事件
      viewmodel.get('cust_name').on('beforeBrowse', function (data) {
        //选中某个所属客户后,往后弹出参照依然显示所有可选客户而不用点击"显示全部"
        this.setState('text', null);

        //选择所属客户之前，如果没有选择库存组织，给出提示
        var stockOrg = viewmodel.get('org_name').getValue();
        if (stockOrg == null || stockOrg == "") {
          cb.utils.alert('请先选择库存组织!');
          return false;
        } else {
          viewmodel.get('cust_name').setDisabled(false);
        }
      });




    }
  }


  try {
    module.exports = AA_aa_warehouse_VM_Extend;
  } catch (error) {

  }
  return AA_aa_warehouse_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_warehouse_VM.Extend.js